import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-white px-4">
            <div className="max-w-lg w-full text-center">
                <h1 className="text-9xl font-bold text-black mb-4">404</h1>
                <h2 className="text-2xl font-medium text-gray-800 mb-8">Page Not Found</h2>
                <p className="text-gray-600 mb-8">
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <button
                    onClick={() => navigate('/')}
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-black hover:bg-gray-900 focus:outline-none transition duration-150 ease-in-out"
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default NotFound; 